import { createFileRoute } from "@tanstack/react-router";
import ShowroomConfigure from "lib/components/showroom2/pages/ShowroomConfigure";
import { ShowroomOpsProvider } from "lib/components/showroom2/state/useShowroomState";
import { useAppRouterParams } from "lib/routeHelpers";
import withAuthentication from "../../../../components/withAuthentication";

/**
 * Operations mode for a saved `HomePlan`. Exposes `OPERATIONS`-category
 * options and renders a flat grouped list instead of the wizard — ops users
 * want Ctrl+F over a guided flow. Gated on `showroomUnification`.
 */
function ShowroomPlanOps() {
  const { homePlanId, builderId } = useAppRouterParams();
  const showroomKey = [builderId, homePlanId].filter(Boolean).join("-") || undefined;

  return (
    <ShowroomOpsProvider key={showroomKey}>
      <ShowroomConfigure />
    </ShowroomOpsProvider>
  );
}

export const Route = createFileRoute("/showroom/plan/$home_plan_id/ops")({
  component: withAuthentication(ShowroomPlanOps, {
    features: ["showroomUnification"],
    // Both are required. The operator defaults to OR, under which VIEW_HOME_PLANS alone would
    // grant access regardless of a denied VIEW_OPERATIONS_MODE.
    permissions: ["VIEW_OPERATIONS_MODE", "VIEW_HOME_PLANS"],
    permissionOperator: "AND",
    products: ["showroom"],
  }),
});
